export class UserInfo {
  public firstName: string
  public lastName: string
  public phoneNumber: string
  public username: string
  public email: string
  public roles: string[]
  public branchlist: number[]
  public repId: number
  public userRole: string
  public products?: number[]
  public approveProducts?: boolean

  constructor(cons: Partial<UserInfo>) {
    this.firstName = cons?.firstName
    this.lastName = cons?.lastName
    this.phoneNumber = cons?.phoneNumber
    this.username = cons?.username
    this.email = cons?.email
    this.roles = cons?.roles ? cons.roles : []
    this.branchlist = cons?.branchlist ? cons.branchlist : [0]
    this.repId = cons?.repId
    this.userRole = cons?.userRole
    this.products = cons?.products ? cons.products : []
    this.approveProducts = cons?.approveProducts
  }
}
